import React, {useEffect, useState} from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { toast } from "react-toastify";
import { EyWorksDatePicker } from "eyworks-ui-components";
import { ErrorType } from 'src/shared/types/src';
import { verifyDob } from 'src/shared/services/src';
import Images from '../../static';
import Footer from 'src/app/components/commonComponents/Footer';
import CustomButton from 'src/app/components/commonComponents/CustomButton';
import DownloadAppComponent from 'src/app/components/commonComponents/DownloadAppComponent';
import { dateFormatter } from 'src/shared/utils/src';
import { APP_MESSAGES, DATE_FORMATS } from 'src/shared/config/src';
import { AppRoutes } from 'src/app/navigation/routes';
import { getRedirectionRoute } from 'src/app/utilities/helpers';
import { URL_CONSTANTS } from 'src/app/config/appConstants';

const FIELD_MAP = {
    DOB: 'dob'
};

const VerifyDOBScreen = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { email, sessionId, label, otp } = location.state || {};

    const [dob, setDob] = useState<any>();
    const [isVerifying, setIsVerifying] = useState<boolean>(false);
    const [errors, setErrors] = useState<ErrorType>({});
    const [redirectionRoute, setRedirectionRoute] = useState<string>();

    useEffect(() => {
        if (!email) {
            navigate(AppRoutes.VERIFY_EMAIL);
        }
        const redirectTo = getRedirectionRoute();
        if (redirectTo) {
            setRedirectionRoute(redirectTo);
        }
    }, [email])

    const runValidations = () => {
        let errorObj: ErrorType = {};
        if (!dob) {
            errorObj = {
                ...errorObj,
                [FIELD_MAP.DOB]: {
                    isErrored: true,
                    errorMsg: `Date of birth cannot be blank`,
                },
            };
        }
        setErrors(errorObj);

        if (Object.keys(errorObj).length) return false;
        else return true;
    }

    const handleVerifyDob = async () => {
        if (isVerifying) return;

        const validity = runValidations();
        if (!validity) return;

        setIsVerifying(true);
        const formattedDob = dateFormatter(dob, DATE_FORMATS.YMD);


        try {
            const response = await verifyDob({ email, sessionId, dob: formattedDob });
            if (response && Object.keys(response).length > 0) {
                navigate(`${AppRoutes.SET_PASSWORD}${redirectionRoute ? `?${URL_CONSTANTS.REDIRECT_TO}=${redirectionRoute}` : ''}`, {state: { email, sessionId, dob: formattedDob, otp }});
            } else {
                toast.error("Error in DOB verification.", { autoClose: 5000 });
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                const apiError = error as AxiosError;
                if (apiError && apiError.response) {
                    const { errors } = error.response?.data;
                    toast.error(errors.join(", "), {autoClose: 5000});
                } else {
                    toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
                }
            }
        } finally {
            setIsVerifying(false);
        }
    }

    return (
        <div className='main-wrapper bg-white container'>
            <div className='d-flex flex-column flex-grow-1 mg-b-20'>
                <div className='mg-b-78 mg-t-xxl-100 mg-t-xs-50 pd-t-md-30 pd-t-xs-0 d-flex justify-content-center align-items-center'>
                    <img src={Images.logo} alt="logo" className="eyworks-logo" />
                </div>
                <p className='fs-4 text-black fw-bold'>Verify Date of Birth</p>
                <p className='fs-14 text-black mg-b-28'>{label}</p>
                <div className='form-group mg-b-25'>
                    <label className='form-label fs-12'>Date of birth</label>
                    <EyWorksDatePicker
                        optionsDateFormat={'D MMM'}
                        placeholder={'DD-MM-YYYY'}
                        onChange={(val) => setDob(val)}
                        selectedDate={dob}
                    />
                </div>
                {errors && errors[FIELD_MAP.DOB] && errors[FIELD_MAP.DOB].isErrored ? <span>{errors[FIELD_MAP.DOB].errorMsg}</span> : null}
                <CustomButton text={'Next'} onClick={handleVerifyDob} isLoading={isVerifying} color={'primary'} />
            </div>
            <div className='mg-b-10'>
                <DownloadAppComponent />
                <Footer />
            </div>
        </div>
    )
}

export default VerifyDOBScreen;